import React from 'react'
import { useTranslation } from 'react-i18next'
import { css } from '@emotion/core'

type Props = { isDiscount: boolean }

export const TypeLabel: React.FC<Props> = props => {
  const { t } = useTranslation()

  return props.isDiscount ? (
    <div css={labelStyle} className="discount-label">
      {t('Discount')}
    </div>
  ) : (
    <div css={labelStyle} className="sale-label">
      {t('Sales')}
    </div>
  )
}

const labelStyle = css({
  borderRadius: 50,
  width: 'fit-content',
  padding: '4px 8px',
  '&.sale-label': { color: '#ffffff', background: '#2563eb' },
  '&.discount-label': { background: '#f1f5f9' },
})
